import React, { useMemo } from 'react';
import { Tabs } from 'antd';
import 'styles/ant-design.css';
import { SubmissionCurrencyTabProps } from './types';
import { useTranslation } from 'react-i18next';
import { DEFAULT_CONVERSION_CURRENCY } from '../submission-details/types';
import { cn } from 'utils';

const SubmissionCurrencyTab: React.FC<SubmissionCurrencyTabProps> = ({
  activeTab,
  onTabChange,
  originalCurrency,
  className,
  tabPosition,
}) => {
  const { t } = useTranslation();

  const submissionCurrencyTabs = useMemo(() => {
    if (!originalCurrency || originalCurrency === DEFAULT_CONVERSION_CURRENCY) {
      return [
        {
          key: DEFAULT_CONVERSION_CURRENCY,
          label: DEFAULT_CONVERSION_CURRENCY + ' ' + t('general.currency'),
        },
      ];
    }

    return [
      {
        key: originalCurrency,
        label: originalCurrency + ' ' + t('general.currency'),
      },
      {
        key: DEFAULT_CONVERSION_CURRENCY,
        label: DEFAULT_CONVERSION_CURRENCY + ' ' + t('general.currency'),
      },
    ];
  }, [originalCurrency, t]);

  return (
    <Tabs
      activeKey={activeTab}
      onChange={onTabChange}
      items={submissionCurrencyTabs}
      className={cn(className, 'custom-tabs-with-bottom-curve')}
      tabPosition={tabPosition}
    />
  );
};

export default SubmissionCurrencyTab;
